import React from 'react';
import styles from './Badge.module.css';

interface BadgeProps {
  variant: 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'pregnant';
  solid?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ variant, solid = false, children, className = '' }) => (
  <span className={`${styles.badge} ${styles[variant]} ${solid ? styles.solid : ''} ${className}`.trim()}>
    {children}
  </span>
);

export default Badge;
